export default "__VITE_ASSET__CzHHTvaf__"